import * as yup from 'yup';


export const createLessonSchema = yup.object().shape({
    title: yup.string().required(),
    description: yup.string().required(),
    order: yup.number().required(),
    isPreview: yup.boolean().required(),
});